(function () {
    require('../../resources/search');
    require('../search-results/search-results.directive');
    angular.module('far.search').directive('searchBlock', searchBlock);

    function searchBlock() {
        return {
            restrict: 'A',
            controller: controller,
            scope: {
                initialQuery: '=',
                initialItems: '=',
                initialTotal: '=',
                showMore: '=',
                query: '=',
                showFilter: '=',
                search: '=',
                filterButtonText: '=',
                type: '=',
                items: '=',
                total: '='
            }
        }
    }

    /**
     * @param $scope
     * @param {Search} Search
     */
    function controller($scope, Search) {
        $scope.query = $scope.initialQuery;
        $scope.items = $scope.initialItems;
        $scope.total = $scope.initialTotal;
        $scope.search = _.debounce(search, 200);
        $scope.filterButtonText = filterButtonText;
        $scope.showFilter = true;
        $scope.showMore = showMore;

        function filterButtonText() {
            return $scope.showFilter ? 'Скрыть фильтр' : 'Показать фильтр';
        }

        function search(event) {
            if (event) {
                event.preventDefault();
            }

            updateItems();
        }

        function updateItems() {
            Search.search({
                type: $scope.type,
                query: $scope.query
            }).$promise.then(function (searchResults) {
                $scope.items = searchResults.items;
                $scope.total = searchResults.total;
            });
        }

        function showMore() {
            Search.search({
                type: $scope.type,
                query: $scope.query,
                from: $scope.items.length
            }).$promise.then(function (searchResults) {
                $scope.items = $scope.items.concat(searchResults.items);
                $scope.total = searchResults.total;
            });
        }
    }
})();
